import React, { useRef, useState, useEffect, useContext, useCallback, useMemo} from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import axios from "axios";

import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { BarrioContext } from "../components/BarrioContext";
import { useAuth } from "../components/AuthContext";
import { useTerminologia } from "../hooks/useTerminologia";

import LoadingOverlay from '../components/LoadingOverlay';

import { Toast } from 'primereact/toast';

const CargoPeriodoUnidadFuncional = () => {
    const initialFormData = {
      proveedorId: null,
      comprobante: "",
      detalle: "",
      esPrevision: false,
      esFondoManiobra: false,
      esRestarEmpresaOrdinaria: false,
    };
    const toast = useRef(null);
    const [formData, setFormData] = useState(initialFormData);

    const { barrio } = useContext(BarrioContext);
    const { administracionId } = useAuth();
    const t = useTerminologia();

    const [visible, setVisible] = useState(false);

    const location = useLocation();
    const [selectedDate, setSelectedDate] = useState(location.state?.selectedDate ?? new Date());

    const HOST_API = process.env.REACT_APP_URL;

    const [cargos, setCargos] = useState([]);
    const [loadingBackdrop, setLoadingBackdrop] = useState(false);
    const [unidadesFuncionales, setUnidadesFuncionales] = useState([]);

    useEffect(() => {
        if (!barrio?.id) return;
        axios.get(`${HOST_API}api/unidadesFuncionales/getUnidadesFuncionales?unidadFuncionalId=0&administracionId=${administracionId}&barrioId=${barrio.id}`)
            .then(res => setUnidadesFuncionales(res.data))
            .catch(err => console.error('Error cargando unidades funcionales:', err));
    }, [barrio?.id, administracionId]);

    const handleDateChange = (value) => {
      setSelectedDate(value);
    };

  const formatDate = (date) => {
    if (!date) return "";

    const year  = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day   = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { expensaExtraordinaria, fechaVencimiento, ...formDataClean } = formData;
    const payload = {
      ...formDataClean,
        periodo: formatDate(selectedDate),
        barrioId: barrio.id,
        administracionId
    };

    try {
      await axios.post(`${HOST_API}api/cargosPeriodoUF/SaveCargoPeriodoUF`, payload);
      setVisible(false);
      fetchExpensas();
    } catch (err) {
      console.error(err);
    }
  };

   const fetchExpensas = useCallback(async () => {
      if (!selectedDate || !barrio?.id) return;

      setLoadingBackdrop(true);
      try {
        const fecha = formatDate(selectedDate);
        const urlGastos = `${HOST_API}api/cargosPeriodoUF/GetCargosPeriodoUF?barrioId=${barrio.id}&administracionId=${administracionId}&periodo=${fecha}`;
        const response = await axios.get(urlGastos);

        console.log(response.data);
        setCargos(response.data);

      } catch (err) {
        console.error(err.message || "Error al obtener cargos");
      } finally {
        setLoadingBackdrop(false);
      }
    }, [selectedDate, barrio?.id, administracionId]);

    useEffect(() => {
      fetchExpensas();
    }, [fetchExpensas]);

    const flattenRow = (row) => {
      const flat = {};
      for (const [key, value] of Object.entries(row)) {
        if (typeof value === "object" && value !== null && !key.endsWith("_type")) {
          for (const [nestedKey, nestedValue] of Object.entries(value)) {
            flat[nestedKey] = nestedValue;
            flat[`${nestedKey}_type`] = row[`${key}_type`] ?? "currency";
          }
        } else {
          flat[key] = value;
        }
      }
      return flat;
    };

    const cargosFlat = useMemo(() => cargos?.map(flattenRow) ?? [], [cargos]);

    const camelToHeader = (key) => {
      return key
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase())
        .trim();
    };

    const handleChangeCargo = (campo, valor) => {
      setFormData((prev) => ({
        ...prev,
        [campo]: valor,
      }));
    };

    const formatValue = (value, type) => {
      if (value === null || value === undefined) return "";

      switch (type) {
        case "date":
          return new Date(value).toLocaleDateString("es-AR");
        case "currency":
          return typeof value === "number"
            ? value.toLocaleString("es-AR", { style: "currency", currency: "ARS" })
            : value;
        default:
          return typeof value === "object" ? JSON.stringify(value) : value;
      }
    };

    const columns = useMemo(() => {
      if (!cargosFlat?.length) return [];

      const firstRow = cargosFlat[0];

      return Object.keys(firstRow)
        .filter((key) => !key.endsWith("_type") && key !== 'razonSocial' && key !== 'administracionId' && key !== 'barrioId' && key !== 'unidadFuncionalId' && key !== 'fechaAlta')
        .map((field) => ({
          field,
          type: firstRow[`${field}_type`] ?? "text",
          header: camelToHeader(field),
        }));
    }, [cargos]);

    // â”€â”€â”€ Edit / Delete â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleEdit = (row) => {
        setFormData({ ...initialFormData, ...row, unidadFuncionalId: Number(row.unidadFuncionalId) || null });
        setVisible(true);
    };

    const handleDelete = (id) => {
        confirmDialog({
            message: '¿Estás seguro de eliminar este cargo?',
            header: 'Confirmar eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Eliminar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await axios.delete(`${HOST_API}api/cargosPeriodoUF/DeleteCargoPeriodoUF/${id}`);
                    fetchExpensas();
                } catch (err) {
                    console.error(err);
                }
            },
        });
    };

    return (
      <>

        <h4>Cargo Periodo {t.UnidadFuncional}</h4>
        <br></br>

        <ConfirmDialog />
        <Toast ref={toast} />
        <LoadingOverlay visible={loadingBackdrop} />

        <div className="flex align-items-center gap-3">

        <div className="flex gap-2">
              <Button
                  label="Nuevo cargo"
                  icon="pi pi-shopping-cart"
                  onClick={() => setVisible(true)}
              />
          </div>

          <Calendar
              value={selectedDate}
              view="month"
              dateFormat="mm/yy"
              onChange={(e) => handleDateChange(e.value)}
              showIcon
              className="p-inputtext-sm"
          />
      </div>

      <br></br>

        <div className="grid">
                <Dialog
                    header={`Cargo Periodo ${t.UnidadFuncional}`}
                    visible={visible}
                    style={{ width: "70vw" }}
                    breakpoints={{ "960px": "100vw" }}
                    modal
                    onHide={() => setVisible(false)}
                >
                  <form className="p-fluid grid" onSubmit={handleSubmit}>
                    <div className="col-12 md:col-12">
                      <div className="col-12 flex flex-wrap gap-3 mt-3">

                        <div className="w-full md:w-4">
                          <label>{t.UnidadFuncional}</label>
                          <Dropdown
                            value={formData.unidadFuncionalId || null}
                            options={unidadesFuncionales}
                            optionLabel="unidadFuncional"
                            optionValue="unidadFuncionalId"
                            onChange={(e) => handleChangeCargo("unidadFuncionalId", e.value)}
                            placeholder={`Seleccionar ${t.UF}`}
                            className="p-inputtext-sm w-full"
                            filter
                          />
                        </div>

                        <div className="w-full md:w-4">
                          <label>Importe</label>
                          <InputText
                            type="number"
                            step="0.01"
                            value={formData.importe || ""}
                            onChange={(e) => handleChangeCargo("importe", e.target.value)}
                            className="p-inputtext-sm w-full"
                          />
                        </div>


                        <div className="w-full">
                          <label>Observaciones</label>
                          <InputText
                            type="text"
                            value={formData.observaciones || ""}
                            onChange={(e) => handleChangeCargo("observaciones", e.target.value)}
                            className="p-inputtext-sm w-full"
                          />
                        </div>

                        <div className="col-12 mt-3">
                          <Button label="Guardar" icon="pi pi-save" type="submit" />
                        </div>

                      </div>
                  </div>
                </form>

                </Dialog>


            <div className="col-12 md:col-12">

              <DataTable
                value={cargosFlat}
                paginator
                rows={10}
                showGridlines
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                responsiveLayout="scroll"
                emptyMessage="No hay cargos cargadas"
                className="p-datatable-gridlines bg-white"
              >
                {columns.map(({ field, header, type }) => (
                  <Column
                    key={field}
                    field={field}
                    header={header}
                    sortable
                    body={(row) => formatValue(row[field], type)}
                  />
                ))}
                <Column
                    header="Acciones"
                    style={{ width: '8rem' }}
                    body={(row) => (
                        <div className="flex gap-2 justify-content-center">
                            <Button icon="pi pi-pencil" rounded text severity="warning" onClick={() => handleEdit(row)} tooltip="Editar" />
                            <Button icon="pi pi-trash" rounded className="btn-delete" onClick={() => handleDelete(row.cargoPeriodoUFId)} tooltip="Eliminar" />
                        </div>
                    )}
                />
              </DataTable>


            </div>

        </div>
        </>
    );
};

export default CargoPeriodoUnidadFuncional;
